import authRules from '../authRules';

const removeDayTypeRequest = (user) => {
  const { deleteDaysOffRequest } = user.securityLevels;
  if (deleteDaysOffRequest >= authRules.removeDayTypeRequest.deleteDaysOffRequest) {
      return true;
  } else {
      return false;
    }
  }


export default removeDayTypeRequest;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/removeDayTypeRequest.js